/**
 * 车队运行看板
 */
import React from 'react';
import { Button } from 'antd';

const FLEET_DASHBOARD_URL = 'https://b.datav.run/share/page/5a6f56be5b4abb7276c9969ddac444c1';

const FleetDashboard = () => {
  const goFleetDashboard = () => {
    window.open(FLEET_DASHBOARD_URL);
  };

  return (
    <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Button type="primary" onClick={goFleetDashboard}>跳转到车队运行看板</Button>
    </div>
  );
};

export default FleetDashboard;
